import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import { YesNoFieldModel } from '../../../../../models/form/fields/yesNo';
import YesNoNa from '../../../../library/inputs/yesNo/YesNoNa';

interface Props {
  id: string;
  value: YesNoFieldModel['defaultValue'];
  enabled: boolean;
  allowNa: boolean;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  readOnlyMode?: boolean;
}

const YesNoField: FC<Props> = ({
  id,
  value,
  enabled,
  allowNa,
  setFieldTouched,
  setFieldValue,
  readOnlyMode,
}: Props) => {
  return (
    <YesNoNa
      value={value}
      enabled={enabled}
      allowNa={allowNa}
      onChange={async (val) => {
        await setFieldValue(id, val, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default YesNoField;
